import { inject, Injectable, signal } from '@angular/core';
import { ApolloService } from '@services/apollo/apollo.service';
import {
  AuthorizedJurisdiction,
  AuthorizedJurisdictionsCollectionSegment,
} from '@wageService/wage.types';
import { AuthorizedJurisdictionInfoQueryVars } from '@setup/prevailing-wage-setup/master-wage-data/interfaces/authorized-jurisdiction-info-query-vars.interface';
import { environment } from 'src/environments/environment';
import { AUTHORIZED_JURISDICTION_INFO } from './graphql/authorized-jurisdiction-info.query';
import { AuthorizedJurisdictionResponse } from '../../../../../shared/interfaces/authorized-jurisdiction-response.interface';
import { AUTHORIZED_JURISDICTIONS_ALL } from './graphql/authorized-jurisdictions-all.query';
import { AuthorizedJurisdictionAllQueryVars } from './interfaces/authorized-jurisdictions-all-vars.interface';
import { AuthorizedJurisdictionAllResponse } from './interfaces/authorized-jurisdictions-all-response.interface';

@Injectable({
  providedIn: 'root',
})
export class AuthorizedJurisdictionsService {
  authorizedJurisdictionsCollectionSegment = signal<
    Partial<AuthorizedJurisdictionsCollectionSegment>
  >({});

  private readonly _serverName: string = environment.graphql.wagedata.name;

  private readonly _apolloService = inject(ApolloService);

  getAuthorizedJurisdictionInfoQuery(
    vars: AuthorizedJurisdictionInfoQueryVars
  ) {
    return this._apolloService.query<AuthorizedJurisdictionResponse>(
      this._serverName,
      AUTHORIZED_JURISDICTION_INFO,
      vars
    );
  }
  getAuthorizedJurisdictionsAll(vars: AuthorizedJurisdictionAllQueryVars) {
    return this._apolloService.query<AuthorizedJurisdictionAllResponse>(
      this._serverName,
      AUTHORIZED_JURISDICTIONS_ALL,
      vars
    );
  }

  setAuthorizedJurisdictionsInfo(
    authorizedJurisdictionCollectionSegment: Partial<AuthorizedJurisdictionsCollectionSegment>
  ): void {
    this.authorizedJurisdictionsCollectionSegment.set(
      authorizedJurisdictionCollectionSegment
    );
  }

  getAuthorizedJurisdictionsInfoValue(): Partial<AuthorizedJurisdiction[]> {
    const authorizedJurisdictions =
      this.authorizedJurisdictionsCollectionSegment().items;

    if (authorizedJurisdictions) {
      return authorizedJurisdictions;
    }

    return [];
  }
}
